<template>
  <portal to="popups_container">
    <div class="popup">
      <EventListener @keydown.prevent.escape="requestClose" />
      <div
        class="popup__content"
        :class="{ 'popup__content--disable-scroll': disableScroll }"
      >
        <div
          v-if="closeAllowed"
          @click="requestClose"
          class="popup__close_button"
        >
          <font-awesome-icon
            class="close_button__icon"
            :icon="['fas', 'times']"
          />
        </div>
        <slot></slot>
      </div>
      <div class="popup__overlay" @click="requestClose"></div>
    </div>
  </portal>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EventListener from "../atoms/EventListener.vue";

library.add(faTimes);

export default {
  name: "Popup",
  components: {
    EventListener,
    FontAwesomeIcon,
  },
  props: {
    closeAllowed: {
      type: Boolean,
      default: true,
    },
    popupID: {
      type: String,
    },
    onClose: {
      type: Function,
    },
    disableScroll: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    requestClose() {
      if (!this.closeAllowed) return;
      this.$emit("close");
      if (!this.popupID) return;
      this.onClose();
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 100%;
}
</style>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";

.popup__content {
  position: fixed;
  margin-top: 50vh;
  margin-left: 50vw;
  // The .5 is subtracted because a Webkit bug, where the text blurs if you don't subtract it
  transform: translate3d(-50%, -50%, 0px);
  z-index: 21;
  width: auto;
  max-width: 600px;
  min-height: 200px;
  background: $white;
  border: 1px solid $grey_mischka;
  border-radius: 4px;
  box-shadow: 0 10px 20px 0 rgba(30, 30, 30, 0.05);
  padding: 16px 24px 24px;
  overflow: auto;

  &.popup__content--disable-scroll {
    overflow: visible;
  }

  @media screen and (min-width: 1000px) {
    min-width: 400px;
    max-width: 100%;
  }
  @media screen and (max-width: 1000px) {
    height: 100vh;
    width: 100vw;
    margin-top: 0px;
    margin-left: 0px;
    transform: translate(0%, 0%);
    border-radius: 0px;
    border: 0px;
  }
}
.popup__overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 20;
  width: 100vw;
  height: 100vh;
  background: $white;
  opacity: 0.6;
}
.popup__close_button {
  position: absolute;
  right: 8px;
  top: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: $grey_french;

  &:hover {
    cursor: pointer;
    background: $grey_bg;
    color: $grey_shark;
  }
}
</style>
